<template>
	<div class="Fileadministration">
		<div class="FileadministrationFixedWidth">
			<div class="tabs">
				<div class="tab-item" :class="{active: activeTab === '授权书'}" @click="changeTab('授权书')">授权书</div>
				<div class="tab-item" :class="{active: activeTab === '采购指标'}" @click="changeTab('采购指标')">采购指标</div>
			</div>
			<FileadministrationTop ref="fileTop" :activeTab="activeTab" @select="select"></FileadministrationTop>
			<div class="TableList">
				<FileadministrationTable :tableData="tableData" :activeTab="activeTab"></FileadministrationTable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange"
						@handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FileadministrationTop from './components/fileadministrationTop.vue'
	import FileadministrationTable from './components/fileadministrationTable.vue'
	import Pagination from '@/components/pagination.vue'
	import {
		FileManageList
	} from '@/api/channel'
	export default {
		components: {
			FileadministrationTop,
			FileadministrationTable,
			Pagination
		},

		data() {
			return {
				pageSize: 10,
				pageIndex: 1,
				total: 0,
				tableData: [],
				activeTab: '授权书',
				searchParams: null
			}
		},
		mounted() {
			// 列表接口
			this.FileManageList()
		},
		methods: {
			changeTab(tab) {
				this.activeTab = tab
				this.pageIndex = 1
				this.$nextTick(() => {
					this.$refs.fileTop.reset()
				})
			},
			//加载列表  
			async FileManageList(FromArr) {
				if (FromArr) {
					this.searchParams = FromArr
				}
				const params = {
					FileType: this.activeTab,
					CreateTime1: this.searchParams ? this.searchParams[0].StartTime : '',
					CreateTime2: this.searchParams ? this.searchParams[0].EndTime : '',
					Title: this.searchParams ? this.searchParams[1].modelvalue : '',
					pageSize: this.pageSize,
					pageIndex: this.pageIndex
				}

				if (this.activeTab === '授权书' && this.searchParams && this.searchParams[2]) {
					params.HospitalName = this.searchParams[2].modelvalue
				}

				let {
					code,
					message,
					data
				} = await FileManageList(params)
				if (code == 0) {
					this.total = data.Count
					data.data.map((item, index) => {
						item.Attachment = {
							Download: '下载'
						}
						if (item.RejectReason) {
							item.Attachment.ReasonText = '驳回原因';
						}
						return item;
					})
					this.tableData = data.data
				}
			},
			// 搜索
			select(FromArr) {
				this.pageIndex = 1
				this.FileManageList(FromArr)
			},
			// 页码
			handleCurrentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.FileManageList()
			},
			// 每页显示数量
			handleSizeChange(pageSize) {
				this.pageSize = pageSize
				this.FileManageList()

			}
		}
	}
</script>

<style lang="less" scoped>
	.Fileadministration {
		width: 100%;

		.FileadministrationFixedWidth {
			width: 1200px;
			min-height: 650px;
			margin: 0px auto 0px auto;
			position: relative;
			top: 20px;

			.tabs {
				display: flex;
				background: #ffffff;
				border-radius: 4px 4px 0 0;
				border: 1px solid #eaecef;
				border-bottom: none;
				padding: 10px 20px 0;

				.tab-item {
					padding: 10px 20px;
					cursor: pointer;
					color: #666;
					font-size: 16px;
					position: relative;
					margin-right: 20px;

					&.active {
						color: #e60012;
						font-weight: bold;

						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 0;
							width: 100%;
							height: 2px;
							background: #e60012;
						}
					}
				}
			}

			.TableList {
				background: #ffffff;
				border-radius: 0 0 4px 4px;
				opacity: 1;
				border: 1px solid #eaecef;
				margin-top: 0;
				padding-bottom: 20px;

				.pagination {
					display: flex;
					justify-content: center;
					margin-top: 40px;
					padding-bottom: 20px;
				}
			}
		}
	}
</style>